var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlendedCannonLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1681.04 519.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.86,
    y1: 430.88,
    x2: 1680.96,
    y2: 430.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d22a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#cf2927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#c82826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ba2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#a7211f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8f1c1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#711615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4d0f0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#240707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#000103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#011427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#022547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#033362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#033f78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#044889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#044e95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#04529c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05539e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.94,
    y1: 88.84,
    x2: 1681.04,
    y2: 88.84,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.86,342.03l849.92,177.68,829.18-177.68H1.86ZM859.92,350.18h721.82l-721.82,153.25v-153.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M851.86,0L1.94,177.68h1679.1L851.86,0ZM837.79,165.83H122.62L837.79,21.46v144.37Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.38,269.25l20.98,4.41c-3.22,7.76-8.57,13.53-16.05,17.29-7.48,3.77-16.98,5.65-28.48,5.65-14.23,0-25.93-3.23-35.09-9.68-9.16-6.46-13.74-15.27-13.74-26.47,0-11.83,4.61-21.02,13.82-27.57,9.21-6.55,21.32-9.83,36.33-9.83,13.11,0,23.76,2.58,31.95,7.72,4.87,3.04,8.53,7.4,10.97,13.1l-21.42,3.4c-1.27-3.69-3.91-6.6-7.93-8.73-4.02-2.13-8.91-3.2-14.66-3.2-7.95,0-14.39,1.89-19.34,5.67-4.94,3.78-7.42,9.92-7.42,18.39,0,8.99,2.44,15.39,7.31,19.21,4.87,3.82,11.21,5.72,19,5.72,5.75,0,10.7-1.21,14.84-3.63,4.14-2.43,7.12-6.24,8.92-11.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.31,295.39h-23.54l-9.36-16.15h-42.84l-8.85,16.15h-22.96l41.75-71.12h22.88l42.91,71.12ZM175.47,267.26l-14.76-26.39-14.48,26.39h29.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.75,295.39v-71.12h21.05l43.87,47.49v-47.49h20.1v71.12h-21.71l-43.21-46.37v46.37h-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.61,295.39v-71.12h21.06l43.86,47.49v-47.49h20.1v71.12h-21.71l-43.21-46.37v46.37h-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.88,260.27c0-7.25,1.63-13.33,4.9-18.24,2.44-3.62,5.76-6.87,9.98-9.75,4.21-2.88,8.83-5.01,13.85-6.4,6.68-1.88,14.38-2.82,23.1-2.82,15.79,0,28.43,3.25,37.91,9.75,9.48,6.5,14.22,15.54,14.22,27.12s-4.7,20.46-14.11,26.94c-9.41,6.49-21.98,9.73-37.73,9.73s-28.61-3.23-38.02-9.68c-9.41-6.46-14.11-15.34-14.11-26.66ZM481.17,259.79c0,8.05,2.8,14.16,8.41,18.31,5.6,4.16,12.72,6.23,21.35,6.23s15.71-2.06,21.24-6.18c5.53-4.12,8.3-10.31,8.3-18.56s-2.69-14.23-8.08-18.24c-5.39-4.01-12.54-6.01-21.46-6.01s-16.11,2.03-21.57,6.09c-5.45,4.06-8.19,10.18-8.19,18.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.68,295.39v-71.12h21.05l43.87,47.49v-47.49h20.1v71.12h-21.71l-43.21-46.37v46.37h-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.24,269.25l20.98,4.41c-3.21,7.76-8.56,13.53-16.04,17.29-7.48,3.77-16.97,5.65-28.47,5.65-14.23,0-25.93-3.23-35.09-9.68-9.16-6.46-13.75-15.27-13.75-26.47,0-11.83,4.61-21.02,13.82-27.57,9.21-6.55,21.32-9.83,36.34-9.83,13.11,0,23.76,2.58,31.95,7.72,4.87,3.04,8.53,7.4,10.96,13.1l-21.42,3.4c-1.27-3.69-3.91-6.6-7.93-8.73-4.02-2.13-8.91-3.2-14.65-3.2-7.95,0-14.39,1.89-19.34,5.67-4.95,3.78-7.42,9.92-7.42,18.39,0,8.99,2.44,15.39,7.31,19.21,4.88,3.82,11.21,5.72,19.01,5.72,5.75,0,10.7-1.21,14.84-3.63,4.14-2.43,7.11-6.24,8.91-11.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.14,260.27c0-7.25,1.63-13.33,4.9-18.24,2.44-3.62,5.76-6.87,9.98-9.75,4.21-2.88,8.83-5.01,13.85-6.4,6.68-1.88,14.37-2.82,23.09-2.82,15.8,0,28.44,3.25,37.92,9.75,9.48,6.5,14.22,15.54,14.22,27.12s-4.71,20.46-14.11,26.94c-9.41,6.49-21.98,9.73-37.72,9.73s-28.61-3.23-38.01-9.68c-9.41-6.46-14.11-15.34-14.11-26.66ZM882.44,259.79c0,8.05,2.8,14.16,8.41,18.31,5.6,4.16,12.72,6.23,21.35,6.23s15.71-2.06,21.24-6.18c5.53-4.12,8.3-10.31,8.3-18.56s-2.69-14.23-8.08-18.24c-5.39-4.01-12.54-6.01-21.46-6.01s-16.11,2.03-21.57,6.09c-5.46,4.06-8.18,10.18-8.18,18.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.43,295.39v-71.12h32.39l19.44,48.51,19.23-48.51h32.46v71.12h-20.11v-55.98l-21.27,55.98h-20.83l-21.21-55.98v55.98h-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.19,295.39v-71.12h34.73c13.16,0,21.73.36,25.73,1.06,6.14,1.07,11.28,3.39,15.42,6.96,4.15,3.58,6.22,8.19,6.22,13.85,0,4.37-1.2,8.03-3.59,11.01-2.38,2.98-5.42,5.31-9.1,7.01-3.68,1.7-7.42,2.82-11.22,3.37-5.17.68-12.65,1.02-22.45,1.02h-14.11v26.83h-21.64ZM1140.83,236.31v20.18h11.84c8.53,0,14.24-.37,17.11-1.12,2.87-.74,5.12-1.91,6.76-3.49,1.63-1.58,2.45-3.43,2.45-5.53,0-2.59-1.14-4.72-3.43-6.4-2.29-1.68-5.19-2.73-8.69-3.15-2.59-.32-7.78-.48-15.57-.48h-10.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.33,295.39h-23.55l-9.36-16.15h-42.84l-8.84,16.15h-22.96l41.74-71.12h22.88l42.92,71.12ZM1271.48,267.26l-14.77-26.39-14.48,26.39h29.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.76,295.39v-71.12h21.06l43.87,47.49v-47.49h20.11v71.12h-21.72l-43.2-46.37v46.37h-20.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.75,295.39v-71.12h21.65v71.12h-21.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.75,295.39v-71.12h79.46v12.03h-57.83v15.76h53.81v11.98h-53.81v19.36h59.88v11.98h-81.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.86,272.25l21.05-1.36c1.28,4.69,3.84,8.14,7.72,10.33,3.87,2.2,9.11,3.3,15.68,3.3,6.97,0,12.22-.97,15.75-2.93,3.54-1.95,5.3-4.25,5.3-6.87,0-1.68-.74-3.11-2.22-4.29-1.49-1.18-4.09-2.21-7.79-3.09-2.53-.58-8.31-1.61-17.33-3.1-11.6-1.91-19.74-4.25-24.42-7.03-6.58-3.91-9.87-8.68-9.87-14.31,0-3.62,1.54-7.01,4.64-10.16,3.1-3.15,7.55-5.56,13.37-7.21,5.83-1.65,12.86-2.48,21.1-2.48,13.45,0,23.58,1.96,30.38,5.87,6.79,3.91,10.37,9.14,10.7,15.67l-21.64.63c-.92-3.65-2.91-6.28-5.95-7.88-3.04-1.6-7.62-2.4-13.7-2.4s-11.21.86-14.77,2.57c-2.29,1.1-3.44,2.57-3.44,4.42,0,1.68,1.08,3.12,3.22,4.32,2.73,1.52,9.36,3.11,19.89,4.75,10.52,1.65,18.31,3.36,23.35,5.12,5.05,1.76,9,4.17,11.85,7.23,2.85,3.06,4.28,6.83,4.28,11.33,0,4.07-1.71,7.89-5.12,11.45-3.41,3.56-8.24,6.21-14.47,7.93-6.24,1.74-14.01,2.6-23.32,2.6-13.56,0-23.95-2.08-31.22-6.24-7.26-4.16-11.6-10.21-13.02-18.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlendedCannonLogo);
export default __webpack_public_path__ + "static/media/blended_cannon_logo.0ea1a88c6cba942b21a8d228911839d9.svg";
export { ForwardRef as ReactComponent };